<template>
  <div>
    <div>
      <h2>"人努力-天帮忙"指数坐标图</h2>
    </div>

    <div style="text-align: left">
      <el-collapse accordion>
        <el-collapse-item>
          <template slot="title">
            <span style="color: #f56c6c"
              >什么是"人努力-天帮忙"指数？<i
                class="header-icon el-icon-info"
              ></i
            ></span>
          </template>
          <div>
            结合原始污染物浓度与气象调整后的污染物浓度，分解气象和人为因素的影响，计算“人努力—天帮忙”指数
            <br />
            用该年原始浓度与调整后浓度差值相对上一年原始浓度的比率衡量该年气象影响（“天是否帮忙”），
            <span style="color: #f56c6c">正值</span
            >表示气象条件不利，即“天不帮忙”，
            <span style="color: #409eff">负值</span
            >表示气象条件有利，即“天帮忙”；
            <br />
            用连续两年调整后浓度差值相对上一年原始浓度的比率衡量排放水平变化（“人是否努力”），
            <span style="color: #f56c6c">正值</span
            >代表背景浓度上升，即“人不努力”，
            <span style="color: #409eff">负值</span
            >代表背景浓度下降，即“人努力”。
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div style="text-align: left; margin-top: 15px">
      <el-row>
        评估时间：
        <!-- <el-date-picker
          v-model="assessYear"
          type="year"
          placeholder="选择评估年份"
          :picker-options="pickerOptions"
          @change="assessYearChange"
          size="mini"
        ></el-date-picker> -->

        <el-select
          size="mini"
          v-model="assessYear"
          placeholder="请选择"
          @change="assessYearChange"
        >
          <el-option
            v-for="item in Years"
            :key="item"
            :label="item + '年'"
            :value="item"
          ></el-option>
        </el-select>
        <el-select
          size="mini"
          v-model="assessSeason"
          placeholder="请选择"
          @change="assessSeasonChange"
        >
          <el-option
            v-for="item in Seasons"
            :key="item.name"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-row>
    </div>

    <!-- 图像下载 -->
    <div>
      <el-row type="flex" justify="end">
        <el-button
          type="success"
          icon="el-icon-download"
          @click="downloadImage"
          :loading="imageDownloading"
          >图像下载</el-button
        >
      </el-row>
    </div>

    <div id="city-hw-axis-chart-canvas">
      <div
        id="city-hw-axis-chart"
        :style="{
          height: eleheight + 'px',
        }"
      ></div>
    </div>
  </div>
</template>

<style scoped>
/* .el-button {
  border-width: 0px;
  color: black;
  padding: 0 10px;
  margin: 0;
} */

.el-row {
  margin-bottom: 15px;
}
.el-divider {
  margin: 0;
  /* margin-bottom: 10px; */
}
</style>

<script>
// // @ is an alias to /src
import { getSeasonZH } from "@/assets/js/my-utils.js";
import { GenerateMapImgFromDom } from "@/assets/js/utils-map.js";

export default {
  name: "Platform",
  data() {
    return {
      eleheight: 520,
      chart: [],
      isMobile: false,
      assessPull: "PM2.5",
      assessPullContent: "h",

      assessYear: "2023",
      assessSeason: 1,
      Years: [
        "2023",
        "2022",
        "2021",
        "2020",
        "2019",
        "2018",
        "2017",
        "2016",
        "2015",
        "2014",
      ],

      Seasons: [
        {
          name: "春季",
          value: 1,
        },
        {
          name: "夏季",
          value: 2,
        },
        {
          name: "秋季",
          value: 3,
        },
        {
          name: "冬季",
          value: 4,
        },
        {
          name: "年均",
          value: 0,
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > 2020 || time.getFullYear() < 2014;
        },
      },
      chart_line_data: [],
      // chartName: "cityareahwheatmap",
    };
  },
  components: {},
  methods: {
    downloadImage() {
      let imageDom = document.getElementById("city-hw-axis-chart-canvas");

      let title;
      let seasonZh = ["", "春季", "夏季", "秋季", "冬季"];
      let time = this.assessYear + "年" + seasonZh[this.assessSeason];
      (title = time + '"人努力-天帮忙"指数坐标图'),
        GenerateMapImgFromDom(imageDom, title + ".png");
    },
    getHWindexData() {
      let axiosPosts = [];
      if (this.chart_line_data.length <= 0) {

        let url = "/AQAssess/getAreaHWindex/" + this.assessPull + "/" + this.assessYear + "/" + this.assessSeason;
        axiosPosts.push(
          this.$axios.get(url + "/hindex")
        );

        axiosPosts.push(
          this.$axios.get(url + "/windex")
        );
        let temp_chart_line_data = [];
        // 获取数据
        const that = this;
        this.$axios.all(axiosPosts).then(
          this.$axios.spread(function (hindex, windex) {
            // 将数据合并
            hindex.data.forEach((element) => {
              for (let i = 0; i < windex.data.length; i++) {
                if (element[0] == windex.data[i][0]) {
                  temp_chart_line_data.push([
                    element[0],
                    element[1],
                    windex.data[i][1],
                  ]);
                }
              }
            });
            // 两个请求现在都执行完成
            that.chart_line_data = temp_chart_line_data;
            if (temp_chart_line_data.length < 1) {
              that.$message.error("当前季度没有数据");
            } else {
              that.drawHWindexAxisChart(that.chart[0]);
            }

            // console.log(that.chart_line_data);
          })
        );
      } else {
        this.drawHWindexAxisChart(this.chart[0]);
      }
    },

    drawHWindexAxisChart(chart) {
      let data = [];
      let seasonZh = ["", "春季", "夏季", "秋季", "冬季"];
      let time = this.assessYear + "年" + seasonZh[this.assessSeason];

      let hindex = [];
      let windex = [];
      let bothindex = [];
      let noneindex = [];

      let xMax = 0;
      let yMax = 0;

      this.assesscity.forEach((element) => {
        for (let i = 0; i < this.chart_line_data.length; i++) {
          if (this.chart_line_data[i][0] == element[1]) {
            let h = (100 * parseFloat(this.chart_line_data[i][1])).toFixed(1);
            let w = (100 * parseFloat(this.chart_line_data[i][2])).toFixed(1);

            xMax = xMax > Math.abs(h) ? xMax : Math.abs(h);
            yMax = yMax > Math.abs(w) ? yMax : Math.abs(w);

            if (h < 0 && w < 0) {
              bothindex.push([h, w, this.chart_line_data[i][0]]);
            } else if (h < 0) {
              hindex.push([h, w, this.chart_line_data[i][0]]);
            } else if (w < 0) {
              windex.push([h, w, this.chart_line_data[i][0]]);
            } else {
              noneindex.push([h, w, this.chart_line_data[i][0]]);
            }
          }
        }
      });

      xMax = parseInt(xMax) + 1;
      yMax = parseInt(yMax) + 1;

      let option = {
        title: {
          text: time + '"人努力-天帮忙"指数坐标图',
          // subtext: sub_title,
          left: "center",
          padding: 25,
          subtextStyle: {
            color: "#F56C6C",
            fontSize: "14",
          },
        },
        grid: {
          top: 80,
          left: 30,
          right: 20,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            show: true,
            type: "cross", //十字准星指示器。其实是种简写，表示启用两个正交的轴的 axisPointer
            lineStyle: {
              type: "dashed",
              width: 1,
            },
          },
          formatter: function (params) {
            console.log(params);
            let text =
              params[0].data[2] +
              "<br>人努力程度：" +
              params[0].data[0] +
              "%<br>天努力程度：" +
              params[0].data[1] +
              "%";

            return text;
          },
        },
        legend: { top: 50, right: "center" },
        xAxis: {
          type: "value",
          nameLocation: "middle",
          nameTextStyle: {
            padding: 15,
          },
          name: "人努力程度",
          axisLabel: {
            rotate: 0,
          },
          min: -xMax,
          max: xMax,
        },
        yAxis: {
          type: "value",
          name: "天帮忙程度",
          nameLocation: "middle",
          nameTextStyle: {
            padding: 15,
          },
          min: -yMax,
          max: yMax,
        },

        series: [
          {
            name: "人努力且天帮忙",
            data: bothindex,
            color: "#67C23A",
            type: "scatter",
            label: {
              show: true,
              position: "top",
              formatter: function (params) {
                return params.data[2];
              },
            },
            markArea: {
              silent: true,
              itemStyle: {
                normal: {
                  color: "transparent",
                  borderWidth: 3,
                  borderType: "dashed",
                },
              },
              label: {
                show: true,
                color: "#969696",
                formatter: function (data) {
                  return "人努力且天帮忙";
                },
                fontSize: 24,
                position: "inside",
              },
              data: [
                [
                  {
                    coord: [-xMax, -yMax],
                  },
                  {
                    coord: [0, 0],
                  },
                ],
              ],
            },
          },
          {
            data: hindex,
            name: "人努力",
            color: "#E6A23C",
            type: "scatter",
            label: {
              show: true,
              position: "top",
              formatter: function (params) {
                return params.data[2];
              },
            },

            markArea: {
              silent: true,
              itemStyle: {
                normal: {
                  color: "transparent",
                  borderWidth: 3,
                  borderType: "dashed",
                },
              },
              label: {
                show: true,
                color: "#969696",
                formatter: function (data) {
                  return "人努力天不帮忙";
                },
                fontSize: 24,
                position: "inside",
              },
              data: [
                [
                  {
                    coord: [-xMax, 0],
                  },
                  {
                    coord: [0, yMax],
                  },
                ],
              ],
            },
          },
          {
            name: "天帮忙",
            data: windex,
            color: "#409EFF",
            type: "scatter",
            label: {
              show: true,
              position: "top",
              formatter: function (params) {
                return params.data[2];
              },
            },

            markArea: {
              silent: true,
              itemStyle: {
                normal: {
                  color: "transparent",
                  borderWidth: 3,
                  borderType: "dashed",
                },
              },
              label: {
                show: true,
                color: "#969696",
                formatter: function (data) {
                  return "人不努力天帮忙";
                },
                fontSize: 24,
                position: "inside",
              },
              data: [
                [
                  {
                    coord: [0, -yMax],
                  },
                  {
                    coord: [xMax, 0],
                  },
                ],
              ],
            },
          },
          {
            name: "人不努力且天不帮忙",
            data: noneindex,
            color: "#F56C6C",
            type: "scatter",
            label: {
              show: true,
              position: "top",
              formatter: function (params) {
                return params.data[2];
              },
            },

            markArea: {
              silent: true,
              itemStyle: {
                normal: {
                  color: "transparent",
                  borderWidth: 3,
                  borderType: "dashed",
                },
              },
              label: {
                show: true,
                color: "#969696",
                formatter: function (data) {
                  return "人不努力且天不帮忙";
                },
                fontSize: 24,
                position: "inside",
              },
              data: [
                [
                  {
                    coord: [0, 0],
                  },
                  {
                    coord: [xMax, yMax],
                  },
                ],
              ],
            },
          },
        ],
      };

      chart.setOption(option, {
        notMerge: true,
      });
      chart.resize();
      chart.hideLoading();
    },

    updateCharts() {
      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.getHWindexData();
    },

    assessYearChange() {
      this.chart_line_data = [];
      // this.assessYear = this.assessYear.getFullYear() + "";
      this.updateCharts();
    },
    assessSeasonChange() {
      this.chart_line_data = [];
      this.updateCharts();
    },
  },
  watch: {
    assesscity: function (newAssesscity, oldAssesscity) {
      this.assesscity = newAssesscity;
      if (this.show) {
        this.updateCharts();
      }
    },

    show: function (newShow, oldShow) {
      this.show = newShow;
      if (this.show) {
        this.chart.forEach((element) => {
          element.dispose();
        });
        this.chart = [];

        this.chart.push(
          this.$echarts.init(document.getElementById("city-hw-axis-chart"))
        );

        this.updateCharts();
      } else {
        this.chart.forEach((element) => {
          element.clear();
        });
      }
    },
  },
  props: {
    assesscity: {
      type: Array,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return [
          ["直辖市", "北京"],
          ["直辖市", "天津"],
        ];
      },
    },

    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  created() {},
  mounted() {
    if (this.show) {
      this.chart.push(
        this.$echarts.init(document.getElementById("city-hw-axis-chart"))
      );

      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.updateCharts();
    }
    const that = this;
    window.addEventListener("resize", () => {
      that.chart.forEach((element) => {
        element.resize();
      });
    });
  },
};
</script>
